export enum AutoFunnelType {
  SALE_YOUR_PRODUCT = 'sale_your_product',
  QUICK_SALE = 'quick_sale',
  BUILD_YOUR_LIST = 'build_your_list',
  FREE_WEBINAR = 'free_webinar',
  PAID_WEBINAR = 'paid_webinar',
  LEAD_MAGNET = 'lead_magnet',
}
